import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Row, Typography, Badge } from 'seagull';
import { EditAI } from 'seagull/icons';
import { useLocaleKeys } from '~/i18n';
import { GetHelpMeWriteDrawerTID } from './HelpMeWriteDrawer.utils';
const DrawerHeader = ()=>{
    const { HelpMeWriteDrawerTID } = useMemo(()=>GetHelpMeWriteDrawerTID(), []);
    const { t: helpMeWriteTexts } = useLocaleKeys('helpMeWrite');
    return /*#__PURE__*/ _jsxs(Row, {
        gap: 8,
        alignItems: "center",
        testId: HelpMeWriteDrawerTID.Header(),
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                gap: 4,
                children: [
                    /*#__PURE__*/ _jsx(EditAI, {}),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        weight: "normal",
                        children: helpMeWriteTexts.title()
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Badge, {
                skin: "primary",
                rounded: true,
                outlined: true,
                testId: HelpMeWriteDrawerTID.Badge(),
                children: helpMeWriteTexts.beta()
            })
        ]
    });
};
export default DrawerHeader;
